var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileDashboardIcon = function SvgMobileDashboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M10.159 6.75H8.216a.97.97 0 0 0-.965.966V9.66a.965.965 0 0 0 .965.966h1.943a.966.966 0 0 0 .966-.966V7.716a.966.966 0 0 0-.966-.966m0-5.375H2.841a.965.965 0 0 0-.966.966v1.943a.965.965 0 0 0 .966.966h7.318a.965.965 0 0 0 .966-.966V2.341a.966.966 0 0 0-.966-.966M4.783 6.75H2.842a.965.965 0 0 0-.966.966V9.66a.965.965 0 0 0 .966.966h1.943a.966.966 0 0 0 .966-.966V7.716a.97.97 0 0 0-.966-.966"
  })));
};
export default SvgMobileDashboardIcon;